import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItDidntWorkSection } from './components/WhyItDidntWorkSection';
import { UniqueMechanismSection } from './components/UniqueMechanismSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { MidPageCTA } from './components/MidPageCTA';
import { WhoItsForSection } from './components/WhoItsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { TransformationSection } from './components/TransformationSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { StickyBottomBar } from './components/StickyBottomBar';
import { initPixel } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[#F0EDEB] text-[#2D2D2D]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhyItDidntWorkSection data-id="element-3" />
      <UniqueMechanismSection data-id="element-4" />
      <DeliverablesSection data-id="element-5" />
      <MidPageCTA data-id="element-6" />
      <WhoItsForSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <TransformationSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <CTASection data-id="element-11" />
      <Footer data-id="element-12" />
      <StickyBottomBar data-id="element-13" />
    </div>;
}